import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Constantes } from "../environments/constants";
import { Router, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';
import { ApiService } from './servicios/api.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  constructor(private titleService: Title, private _router: Router, private _api: ApiService) {


    // Se establece el título de la página web,
    // Se obtiene de el archivo de las constantes

    this.titleService.setTitle(Constantes.TITULO_PAGINA);

    // Se crea un evento para que cuando el router detecte un cambio de ruta,
    // establezca el scroll de la página a 0 y regrese al inicio

    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    })
  }


  ngOnInit() {

    /**
     * Comprueba que el usuario ya haya recibido un token, 
     * en caso de que no lo tenga debe solicitarlo
     */

    let userToken = this._api.obtenerToken();
    if (!userToken) {
      // solicitar token
      this._api.get('tokenRequest').subscribe(response => {
        let nuevoToken = this._api.reader.read(response, null);
        this._api.establecerToken(nuevoToken);
        this.obtenerLegislaturaActual();
      })
    } else {
      this.obtenerLegislaturaActual();
    }
  }

  // Se obtiene mediante el API, el objeto de la legislatura actual
  // Y se guarda en la propiedad legislaturaActual del ApiService.service

  public obtenerLegislaturaActual() {
    this._api.get('actualLegislatura').subscribe(actualLegislatura => {
      let l = this._api.reader.read(actualLegislatura, [{}])[0];
      this._api.setLegislatura(l);

    })
  }

}
